var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticStyle:{"list-style":"none"}},[_c('div',{staticClass:"donate"},[(_vm.data.is_slam)?_c('div',{staticClass:"donate__icon",style:({
            backgroundColor: _vm.panelDesign.bulletColor,
        })},[(_vm.showSlamIndication)?_c('div',{staticClass:"five-pointed-star",style:({
                '--star-color': _vm.panelDesign.slamColor,
            })}):_c('div',{staticStyle:{"width":"16px"}},[_vm._v(" ")])]):_vm._e(),(!_vm.data.is_slam)?_c('div',{staticClass:"donate__icon",style:({
            backgroundColor: _vm.panelDesign.bulletColor,

        })},[_c('div',{staticStyle:{"width":"16px"}},[_vm._v(" ")])]):_vm._e(),_c('div',[_c('div',{staticClass:"mb-1"},[_c('span',{staticClass:"donate__title",style:({
                    color: _vm.panelDesign.textColor,
                })},[_vm._v(_vm._s(_vm.data.username))]),_c('span',{staticClass:"ml-1 mr-1",style:({
                    color: _vm.panelDesign.textColor,
                })},[_vm._v("donated")]),_c('span',{staticClass:"donate__amount",style:({
                    color: _vm.panelDesign.amountColor,
                })},[_vm._v("$"+_vm._s(_vm.amountCurrency))])]),(_vm.data.desc && _vm.showDedication)?_c('div',{staticClass:"donate__desc",style:({
                color: _vm.panelDesign.textColor,
            })},[_vm._v(" "+_vm._s(_vm.data.desc)+" ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }